import { CoreCurrencyIcon } from '@components'
import { useTkbFeeDiscount } from '@hooks'
import { formatCurrencyForDisplay } from '@utils'
import { ExchangeFeeFromTkbToggle, TkbDiscountHint } from '@views/banking/Exchange/Elements'
import { useGetPaymentAccountsFilteredQuery } from 'mmfintech-backend-api'
import { formatFloat, tr } from 'mmfintech-commons'

import './dashboardFeeDiscountToggle.scss'

// Raw backend code for the Kingdom Coin. Logic/comparisons must use the raw
// code (never the `formatCurrencyForDisplay` label) — see currencyDisplay.ts.
const TKB_CURRENCY_CODES = ['TKB.ERC20', 'TKB']
const TKB_DECIMALS = 2

export const DashboardFeeDiscountToggle = () => {
  const { eligible, active, onToggle, disabled } = useTkbFeeDiscount()

  // Kingdom Coin balance shown inside the popover. We read it from the merchant's
  // TKB payment account rather than `tkb-stats` (which only exposes monthly
  // usage). `skip` avoids the request entirely for non-TKB merchants.
  const { tkbAccount } = useGetPaymentAccountsFilteredQuery(
    { accountStatuses: ['ACTIVE'], size: 200 },
    {
      skip: !eligible,
      selectFromResult: ({ data }) => ({
        tkbAccount: (data as any)?.content?.find((account: any) => TKB_CURRENCY_CODES.includes(account?.currencyCode))
      })
    }
  )

  if (!eligible) return null

  const balance = tkbAccount?.availableBalance ?? tkbAccount?.balance ?? 0
  const balanceUnit = formatCurrencyForDisplay(tkbAccount?.currencyCode) || 'TKB'

  const popoverContent = (
    <div className='tkb-discount-popover-content'>
      <div className='tkb-discount-popover-balance'>
        <span className='tkb-discount-popover-coin'>
          <CoreCurrencyIcon currency={tkbAccount?.currencyCode ?? 'TKB.ERC20'} size='1.6rem' circle />
          {tr('FRONTEND.DASHBOARD.TKB_DISCOUNT.COIN', 'Kingdom Coin')}
        </span>
        <span className='tkb-discount-popover-amount'>
          {formatFloat(balance, TKB_DECIMALS)} <span className='unit'>{balanceUnit}</span>
        </span>
      </div>
      <div className='tkb-discount-popover-text'>
        <TkbDiscountHint />
      </div>
    </div>
  )

  return (
    <div className='dashboard-fee-discount-toggle'>
      <ExchangeFeeFromTkbToggle
        isActive={active}
        disabled={disabled}
        onToggle={onToggle}
        popover={{ id: 'dashboard-tkb-discount', content: popoverContent }}
      />
    </div>
  )
}
